export const MULTI_STEP_SELECT_PROVIDER_AND_TYPE = 'multi-step-select-provider-and-type';
export const ENTER_KEY = 'Enter';
